import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./styles/style.css";

const elem = document.getElementById("root");
const app = (
	<StrictMode>
		<App />
	</StrictMode>
);

// biome-ignore lint/suspicious/noAssignInExpressions: https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
elem && (import.meta.hot.data.root ??= createRoot(elem)).render(app);
